__webpack_require__.p = "https://play.smartico.ai/";